import { axios } from '@/utils/request'
const api = {
  source: '/finance/customerStatement',
}
export function getQueryNeedPay (parameter) {
  return axios({
    url: api.source + '/queryNeedPay',
    method: 'get',
    params: parameter
  })
}
export function queryAlreadyPay (parameter) {
  return axios({
    url: api.source + '/queryAlreadyPay',
    method: 'get',
    params: parameter
  })
}
export function batchNeedSettleAmount (parameter) {
  return axios({
    url: api.source + '/batchNeedSettleAmount',
    method: 'get',
    params: parameter
  })
}
export function batchSettleComplete (parameter) {
  return axios({
    url: api.source + '/batchSettleComplete',
    method: 'post',
    data: parameter,
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 企业生成对账单
export function getcustomerSettleList (parameter) {
  return axios({
    url: api.source + '/settle',
    method: 'post',
    data: parameter,
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getRefundList (parameter) {
  return axios({
    url: api.source + '/refund',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
//
export const sourceExport = api.source + '/export'